import { Storage } from '@/utils/Storage'
import { getUuid } from '@/utils'
import { wxNavigate } from './wx'
import * as Sentry from '@sentry/vue'
import sensors from '@/utils/sa-sdk-javascript'
import { getOSSToken } from '@/api/goapi'

// 传入时间数据和yyyy-MM-dd格式，返回对应的格式化时间
function formatDate(_date, format) {
  const date = new Date(_date)
  if (!(date instanceof Date)) {
    console.error('Invalid date object')
    return ''
  }

  const padZero = num => (num < 10 ? `0${num}` : num)

  const replacements = {
    yyyy: date.getFullYear(),
    MM: padZero(date.getMonth() + 1),
    dd: padZero(date.getDate()),
    HH: padZero(date.getHours()),
    mm: padZero(date.getMinutes()),
    ss: padZero(date.getSeconds())
  }

  return format.replace(/yyyy|MM|dd|HH|mm|ss/g, match => replacements[match])
}

// 根据ua先判断设备类型为安卓还是ios，默认小程序
const fnJudgeDeviceType = () => {
  const userAgent = window.navigator.userAgent

  if (userAgent.toLocaleLowerCase().endsWith('androidpatientapp')) {
    return {
      deviceType: 'Android',
      uaType: 'AndroidPatientApp'
    }
  } else if (userAgent.toLocaleLowerCase().endsWith('iospatientapp')) {
    return {
      deviceType: 'IOS',
      uaType: 'IOSPatientApp'
    }
  } else {
    return {
      deviceType: 'miniprogram',
      uaType: 'patientMiniprogram'
    }
  }
}

// 辅助函数：从路由的查询参数中提取Chat数据
function extractChatDataFromQuery(query: any): Partial<Chat> {
  let third_user_id = '113416353198'

  if (query.third_user_id) {
    third_user_id = query.third_user_id
  } else {
    if (Storage.get('thirdUserId')) {
      third_user_id = Storage.get('thirdUserId')
    } else {
      const uid = getUuid()

      Storage.set('thirdUserId', uid)
      third_user_id = uid
    }
  }

  if (import.meta.env.VITE_APP_ENV === 'production') {
    // 关联神策id
    sensors.login(`ai_${third_user_id}`)
    // // 写入动态公共属性
    // sensors.registerPage({

    // })
  }

  Sentry.setUser({
    id: third_user_id,
    username: third_user_id,
    email: third_user_id
  })

  return {
    app_id: query.app_id || 10001,
    data_source: 1,
    device_type: fnJudgeDeviceType().deviceType,

    // 以下为小程序||App通过url带进来
    third_user_id,
    open_scene: query.open_scene,
    phone: query.phone,
    lat: query.lat,
    lon: query.lon,
    region_id: query.region_id,
    app_inner_id: query.reserve_deal_id || null, // 预问诊专用字段，订单id
    patient_uid: query.patient_uid || null
  }
}

// 小程序||患者app跳转函数
const fnDealWXOrAppNavigate = url => {
  const uaType = fnJudgeDeviceType().uaType

  switch (uaType) {
    case 'AndroidPatientApp':
      window.nativeApp.routeAction(url)
      break
    case 'IOSPatientApp':
      window.webkit.messageHandlers.MyAiAciton.postMessage({
        miniProgramPath: url
      })
      break
    default:
      wxNavigate(url)
      break
  }
}

const uploadFile = (file: File, headers = null, contentType = null): Promise<string> => {
  const file_type = file.type.split('/')[1]

  return new Promise((resolve, reject) => {
    if (file) {
      getOSSToken(`.${file_type}`, contentType).then(res => {
        const uploadUrl = '//' + res.data.put.split('//')[1]
        const params = headers
          ? {
              method: 'PUT',
              body: file,
              headers
            }
          : {
              method: 'PUT',
              body: file
            }

        fetch(uploadUrl, params)
          .then(() => {
            const uploadedUrl = '//' + res.data.get.split('//')[1].split('.com')[0] + '.com/' + res.data.key

            resolve(uploadedUrl)
          })
          .catch(err => {
            reject(err)
          })
      })
    } else {
      reject('没有选中文件')
    }
  })
}

// 两个字符的表情符号判断
// 高代理项
const isHighSurrogate = char => {
  if (!char) return false
  const code = char.charCodeAt(0)
  return code >= 0xd800 && code <= 0xdbff
}

// 低代理项
const isLowSurrogate = char => {
  if (!char) return false
  const code = char.charCodeAt(0)
  return code >= 0xdc00 && code <= 0xdfff
}

// 轮询函数
const fnPoll = (callback: () => Promise<boolean>, interval: number = 1000, maxAttempts: number = 10): Promise<void> => {
  let attempts = 0

  const executePoll = async (): Promise<void> => {
    if (attempts >= maxAttempts) {
      throw new Error('Max attempts reached')
    }

    const shouldStop = await callback()
    if (shouldStop) {
      return
    }

    attempts++
    setTimeout(executePoll, interval)
  }

  return executePoll()
}

export { formatDate, extractChatDataFromQuery, uploadFile, isHighSurrogate, isLowSurrogate, fnPoll, fnJudgeDeviceType, fnDealWXOrAppNavigate }
